module.exports = __webpack_public_path__ + "static/img/11.8dfbbd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/11.png
// module id = VWVx
// module chunks = 0